/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyReturnBillPayments } from 'app/entities/pharmacy-return-bill-payment/pharmacy-return-bill-payment.reducer';
import { getEntities as getPharmacyPaymentHistories } from 'app/entities/pharmacy-payment-history/pharmacy-payment-history.reducer';
import { getEntities as getPharmacyCredits } from 'app/entities/pharmacy-credit/pharmacy-credit.reducer';
import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacySuppliers } from 'app/entities/pharmacy-suppliers/pharmacy-suppliers.reducer';
import { TransactionType } from 'app/shared/model/enumerations/transaction-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-vendor-payment-tracker.reducer';

export const PharmacyVendorPaymentTrackerUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyReturnBillPayments = useAppSelector(state => state.pharmacyReturnBillPayment.entities);
  const pharmacyPaymentHistories = useAppSelector(state => state.pharmacyPaymentHistory.entities);
  const pharmacyCredits = useAppSelector(state => state.pharmacyCredit.entities);
  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacySuppliers = useAppSelector(state => state.pharmacySuppliers.entities);
  const pharmacyVendorPaymentTrackerEntity = useAppSelector(state => state.pharmacyVendorPaymentTracker.entity);
  const loading = useAppSelector(state => state.pharmacyVendorPaymentTracker.loading);
  const updating = useAppSelector(state => state.pharmacyVendorPaymentTracker.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyVendorPaymentTracker.updateSuccess);
  const transactionTypeValues = Object.keys(TransactionType);

  const handleClose = () => {
    navigate(`/pharmacy-vendor-payment-tracker${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyReturnBillPayments({}));
    dispatch(getPharmacyPaymentHistories({}));
    dispatch(getPharmacyCredits({}));
    dispatch(getPharmacies({}));
    dispatch(getPharmacySuppliers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.settledAmount !== undefined && typeof values.settledAmount !== 'number') {
      values.settledAmount = Number(values.settledAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacyVendorPaymentTrackerEntity,
      ...values,
      returnPayment: pharmacyReturnBillPayments.find(it => it.id.toString() === values.returnPayment?.toString()),
      purchasePayment: pharmacyPaymentHistories.find(it => it.id.toString() === values.purchasePayment?.toString()),
      parentCredit: pharmacyCredits.find(it => it.id.toString() === values.parentCredit?.toString()),
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      payedCredit: pharmacyCredits.find(it => it.id.toString() === values.payedCredit?.toString()),
      supplier: pharmacySuppliers.find(it => it.id.toString() === values.supplier?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          transactionType: 'DEBIT_IN',
          ...pharmacyVendorPaymentTrackerEntity,
          returnPayment: pharmacyVendorPaymentTrackerEntity?.returnPayment?.id,
          purchasePayment: pharmacyVendorPaymentTrackerEntity?.purchasePayment?.id,
          parentCredit: pharmacyVendorPaymentTrackerEntity?.parentCredit?.id,
          pharmacy: pharmacyVendorPaymentTrackerEntity?.pharmacy?.id,
          payedCredit: pharmacyVendorPaymentTrackerEntity?.payedCredit?.id,
          supplier: pharmacyVendorPaymentTrackerEntity?.supplier?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.createOrEditLabel"
            data-cy="PharmacyVendorPaymentTrackerCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.pharmacyVendorPaymentTracker.home.createOrEditLabel">
              Create or edit a PharmacyVendorPaymentTracker
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-vendor-payment-tracker-id"
                  label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.settledAmount')}
                id="pharmacy-vendor-payment-tracker-settledAmount"
                name="settledAmount"
                data-cy="settledAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.transactionType')}
                id="pharmacy-vendor-payment-tracker-transactionType"
                name="transactionType"
                data-cy="transactionType"
                type="select"
              >
                {transactionTypeValues.map(transactionType => (
                  <option value={transactionType} key={transactionType}>
                    {translate(`tinyMedicRestApp.TransactionType.${transactionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.addedById')}
                id="pharmacy-vendor-payment-tracker-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.modifiedById')}
                id="pharmacy-vendor-payment-tracker-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.active')}
                id="pharmacy-vendor-payment-tracker-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.cursor')}
                id="pharmacy-vendor-payment-tracker-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.timestampEntry')}
                id="pharmacy-vendor-payment-tracker-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.microSec')}
                id="pharmacy-vendor-payment-tracker-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.lastUpdated')}
                id="pharmacy-vendor-payment-tracker-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-returnPayment"
                name="returnPayment"
                data-cy="returnPayment"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.returnPayment')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyReturnBillPayments
                  ? pharmacyReturnBillPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-purchasePayment"
                name="purchasePayment"
                data-cy="purchasePayment"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.purchasePayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyPaymentHistories
                  ? pharmacyPaymentHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-parentCredit"
                name="parentCredit"
                data-cy="parentCredit"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.parentCredit')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyCredits
                  ? pharmacyCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.pharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-payedCredit"
                name="payedCredit"
                data-cy="payedCredit"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.payedCredit')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyCredits
                  ? pharmacyCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-vendor-payment-tracker-supplier"
                name="supplier"
                data-cy="supplier"
                label={translate('tinyMedicRestApp.pharmacyVendorPaymentTracker.supplier')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacySuppliers
                  ? pharmacySuppliers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-vendor-payment-tracker"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyVendorPaymentTrackerUpdate;
